import React from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { Button, Label, TabBar, TabItem } from '../components';
import cn from 'classnames';
import styles from './LandscapeBaseEditTemplate.module.css';

interface LandscapeIndicatorBaseTemplateProps {
  children: React.ReactNode;
}

const LandscapeIndicatorBaseTemplate: React.FC<
  LandscapeIndicatorBaseTemplateProps
> = ({ children }) => {
  const navigate = useNavigate();
  const { id, landscapeIndicatorId } = useParams();
  const location = useLocation();

  return (
    <div>
      <div className={cn(styles.heading)}>
        <Label content="Update Indicator" size="lg" />
        <Button
          className={styles.buttonLink}
          onClick={() => navigate(`/landscapes/edit/${id}/indicators`)}
          variant="link"
        >
          Back to Landscape detail
        </Button>
      </div>
      <TabBar
        onSelect={(id: string | null) => {
          if (id) {
            navigate(id);
          }
        }}
        defaultSelected={location.pathname}
      >
        <TabItem
          title="Description"
          id={`/landscapes/edit/${id}/indicators/edit/${landscapeIndicatorId}/description`}
        />
        <TabItem
          title="Verification Approach"
          id={`/landscapes/edit/${id}/indicators/edit/${landscapeIndicatorId}/verification-approach`}
        />
        <TabItem
          title="Supporting Documents"
          id={`/landscapes/edit/${id}/indicators/edit/${landscapeIndicatorId}/supporting-documents`}
        />
        <TabItem
          title="External Resources"
          id={`/landscapes/edit/${id}/indicators/edit/${landscapeIndicatorId}/external-resources`}
        />
        <TabItem
          title="Baseline"
          id={`/landscapes/edit/${id}/indicators/edit/${landscapeIndicatorId}/baseline`}
        />
        <TabItem
          title="Target"
          id={`/landscapes/edit/${id}/indicators/edit/${landscapeIndicatorId}/target`}
        />
        <TabItem
          title="Update"
          id={`/landscapes/edit/${id}/indicators/edit/${landscapeIndicatorId}/contribution`}
        />
      </TabBar>
      <main>{children}</main>
    </div>
  );
};

export default LandscapeIndicatorBaseTemplate;
